export const APPOINTMENT_STATUS_ALL = "Tous";

export enum AppointmentStatus {
  PLANNING = "Planification",
  WAITING_TENANT = "Attente validation",
  PLANNED = "Planifié",
  FIRST_REMINDER = "Rappel 1",
  SECOND_REMINDER = "Rappel 2",
  CONFIRMED = "Confirmé",
  TO_PROCESS = "À traiter",
  DONE = "Intervenu",
  FINALIZED = "Finalisé",
  CANCEL = "Annulé",
}

export enum AppointmentStatusSlug {
  PLANNING = "PLANNING",
  WAITING_TENANT = "WAITING_TENANT",
  PLANNED = "PLANNED",
  FIRST_REMINDER = "FIRST_REMINDER",
  SECOND_REMINDER = "SECOND_REMINDER",
  CONFIRMED = "CONFIRMED",
  TO_PROCESS = "TO_PROCESS",
  DONE = "DONE",
  FINALIZED = "FINALIZED",
  CANCEL = "CANCEL",
}

export interface AppointmentStatusValue {
  color: string;
  name?: AppointmentStatus;
  slug: AppointmentStatusSlug | string;
  hint: string;
  notYet?: string;
  bubbleClass?: string;
}

const appointmentStatusValues: AppointmentStatusValue[] = [
  {
    color: "#4883F7",
    name: AppointmentStatus.PLANNING,
    slug: AppointmentStatusSlug.PLANNING,
    hint: "En attente planification.",
    notYet: "",
    bubbleClass: "status-waiting",
  },
  {
    color: "#ECB900",
    name: AppointmentStatus.WAITING_TENANT,
    slug: AppointmentStatusSlug.WAITING_TENANT,
    hint: "SMS de prise de rendez-vous envoyé.",
    notYet: "SMS de prise de rendez-vous pas encore envoyé.",
    bubbleClass: "status-waiting-tenant",
  },
  {
    color: "#11BFA4",
    name: AppointmentStatus.PLANNED,
    slug: AppointmentStatusSlug.PLANNED,
    hint: "Rendez-vous planifié",
    notYet: "Rendez-vous pas encore planifié",
    bubbleClass: "status-planned",
  },
  {
    color: "#FF7D29",
    name: AppointmentStatus.FIRST_REMINDER,
    slug: AppointmentStatusSlug.FIRST_REMINDER,
    hint: "SMS de rappel pour la  prise de rendez-vous envoyé.",
    notYet: "SMS de rappel pour la prise rendez-vous pas encore envoyé.",
    bubbleClass: "status-reminder-1",
  },
  {
    color: "#FF0000",
    name: AppointmentStatus.SECOND_REMINDER,
    slug: AppointmentStatusSlug.SECOND_REMINDER,
    hint: "2ème SMS de rappel pour la  prise de rendez-vous envoyé.",
    notYet:
      "Deuxième sms de rappel pour la prise rendez-vous pas encore envoyé.",
    bubbleClass: "status-reminder-2",
  },
  {
    color: "#641ABF",
    name: AppointmentStatus.CONFIRMED,
    slug: AppointmentStatusSlug.CONFIRMED,
    hint: "L'occupant a confirmé le RDV",
    notYet: "L'opérateur n'est pas encore confirmé",
    bubbleClass: "status-confirmed",
  },
  {
    color: "#666",
    name: AppointmentStatus.DONE,
    slug: AppointmentStatusSlug.DONE,
    hint: "L'opérateur est intervenu",
    notYet: "L'opérateur n'est pas encore intervenu",
    bubbleClass: "status-done",
  },
  {
    color: "#11BFA4",
    name: AppointmentStatus.TO_PROCESS,
    slug: AppointmentStatusSlug.TO_PROCESS,
    hint: "Commande à traité",
    notYet: "",
    bubbleClass: "status-to-process",
  },
  {
    color: "#000D5B",
    name: AppointmentStatus.FINALIZED,
    slug: AppointmentStatusSlug.FINALIZED,
    hint: "Commande finalisée",
    notYet: "",
    bubbleClass: "status-finalized",
  },
  {
    color: "#666",
    name: AppointmentStatus.CANCEL,
    slug: AppointmentStatusSlug.CANCEL,
    hint: "Le RDV à été annulé",
    notYet: "Le RDV n'est pas annulé",
    bubbleClass: "status-cancel",
  },
  {
    color: "#4883F7",
    slug: "ALL",
    hint: "Voir tous les status",
  },
];

export const getAppointmentStatusValues = (
  status: AppointmentStatus | string,
  byName?: boolean
) => {
  if (status === APPOINTMENT_STATUS_ALL) {
    status = "";
  }
  return appointmentStatusValues.filter(
    (entry) => entry[`${byName ? "name" : "slug"}`] === status
  )[0];
};

export const getAppointmentStatusValuesBySlug = (
  status: AppointmentStatus | string,
) => {
  if (status === APPOINTMENT_STATUS_ALL) {
    status = "";
  }
  return appointmentStatusValues.filter((entry) => {
    return entry.slug === status;
  })[0];
};
